import { AppBar, Button, Link, styled } from '@mui/material';

export const GNBHeightNumber = 72;
export const GNBHeight = `${GNBHeightNumber}px`;

export const IconButton = styled(Button)`
  padding: 2px;
  svg {
    width: 28px;
    height: 28px;
  }
  &:hover {
    background-color: var(--dk-bg-muted, #f3f5f6);
  }
`;

export const GNBWrapper = styled(AppBar)`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: ${GNBHeight};
  padding: 0 30px;
  box-shadow: none;
  border-bottom: 1px solid var(--dk-line-strong, #d4d7db);
  background-color: var(--dk-bg, white);
  overflow-x: auto;
`;

export const LogoLink = styled(Link)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 72px;
  height: 32px;
  aspect-ratio: 72 / 32;
  transition: all 0.3s ease-in-out;
  svg {
    width: 100%;
    height: auto;
  }
  @media (max-width: 769px) {
    display: none;
  }
`;
